import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const NoteListItem = ({ className, note }) => (
  <li
    className={classNames('note-list__container-item', className)}
    // eslint-disable-next-line react/no-danger
    dangerouslySetInnerHTML={{ __html: note }}
  />
);

NoteListItem.defaultProps = {
  className: '',
};

NoteListItem.propTypes = {
  className: PropTypes.string,
  note: PropTypes.string.isRequired,
};

export default NoteListItem;
